type RandomPasswordType = 'lowerCase' | 'upperCase' | 'number' | 'symbol'
interface GetRandomPasswordParams {
	length?: number
	type?: RandomPasswordType[]
}

export class User {
	static getRandomPassword(params: GetRandomPasswordParams = {}) {
		const passwordLength: number = params.length ?? 12

		const typeArr: RandomPasswordType[] =
			params.type === undefined
				? ['lowerCase', 'upperCase', 'number', 'symbol']
				: params.type
		const newPasswordArr: string[] = []
		const isIncludedUpper: boolean = typeArr.includes('upperCase')
		const isIncludedLower: boolean = typeArr.includes('lowerCase')
		const isIncludedNumber: boolean = typeArr.includes('number')
		const isIncludedSymbol: boolean = typeArr.includes('symbol')

		const newUser = new User()

		for (let i = 0; i < passwordLength; i++) {
			const letterSelectorIndex: number = i % typeArr.length
			const letterSelector: RandomPasswordType = typeArr[letterSelectorIndex]

			if (isIncludedUpper && letterSelector === 'upperCase') {
				newPasswordArr.push(newUser.getRandomUpper())
			}

			if (isIncludedLower && letterSelector === 'lowerCase') {
				newPasswordArr.push(newUser.getRandomLower())
			}

			if (isIncludedNumber && letterSelector === 'number') {
				newPasswordArr.push(newUser.getRandomNumber())
			}

			if (isIncludedSymbol && letterSelector === 'symbol') {
				newPasswordArr.push(newUser.getRandomSymbol())
			}
		}

		const result: string = newUser.passwordShuffle(newPasswordArr).join('')

		return result
	}

	getRandomLower(): string {
		const lowerCaseStr = 'abcdefghijklmnopqrstuvwxyz'
		const char = Math.floor(Math.random() * lowerCaseStr.length)
		const letter: string = lowerCaseStr.charAt(char)
		return letter
	}

	getRandomUpper(): string {
		const upperCaseStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
		const char = Math.floor(Math.random() * upperCaseStr.length)
		const letter: string = upperCaseStr.charAt(char)
		return letter
	}

	getRandomNumber(): string {
		return String.fromCharCode(Math.floor(Math.random() * 10) + 48)
	}

	getRandomSymbol(): string {
		const symbols = '!@#$%^*+=-'
		return symbols[Math.floor(Math.random() * symbols.length)]
	}

	passwordShuffle(array: string[]): string[] {
		let currentIndex = array.length

		while (currentIndex != 0) {
			const randomIndex = Math.floor(Math.random() * currentIndex)
			currentIndex--
			;[array[currentIndex], array[randomIndex]] = [
				array[randomIndex],
				array[currentIndex],
			]
		}

		return array
	}
}
